<topo-modal
  (close)="cancelClick()"
  [isActive]="true"
  [isCard]="true"
  [noBodyPadding]="true"
  [rawWidth]="'80vw'"
  [rawHeight]="'80vh'">
  <div class="modal-header">
    <div
      fxLayout="row"
      fxLayoutAlign="space-between center">
      <h5 class="mx-4 my-4">
        {{ 'MAP.SET-LOCATION' | translate }}
      </h5>
      <div
        class="dialog-close"
        (click)="cancelClick()">
        <i class="icon icon-close-X"></i>
      </div>
    </div>
  </div>
  <div class="modal-body mt-2 select-location">
    <topo-select-map-location-body
      [width]="'80vw'"
      [height]="'80vh'"
      [location]="location"
      (pinLocationChanged)="selectedPinLocation($event)"></topo-select-map-location-body>
  </div>
  <div class="modal-footer">
    <div
      fxLayout="row"
      fxLayoutAlign="end"
      class="mt-4 mb-4">
      <div class="mr-3">
        <button
          class="button is-secondary"
          (click)="cancelClick()">
          {{ 'MAP.BUTTONS.CANCEL' | translate }}
        </button>
      </div>
      <div>
        <button
          class="button is-primary"
          (click)="saveClick()">
          {{ 'MAP.BUTTONS.SAVE' | translate }}
        </button>
      </div>
    </div>
  </div>
</topo-modal>
